import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import { units } from "../../../../types/units";

export const RoundedBlueButton = styled(Button)`
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  border: 2px solid;
  min-width: 80px;
  ${units({
    color: "skyBlue",
    borderColor: "skyBlue",
    backgroundColor: "white",
    fontSize: "body",
    "&:hover": {
      color: "skyBlue",
      backgroundColor: "lightGrey",
    },
    "&.active": {
      color: "white",
      backgroundColor: "skyBlue",
      "&:hover": {
        color: "white",
        backgroundColor: "deepSkyBlue",
      },
    },
  })};
`;
